/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2022-06-01 09:37:11
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-06-27 17:52:41
 * @FilePath: \合联\oms\src\api\order\returnPick.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "@/libs/api.request";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/shipments/returnPickup",
    params,
    method: "post"
  });
};
// // 创建列表
// export const add = data => {
//   return axios.request({
//     url: "/warehouse/refunds",
//     method: "post",
//     data
//   });
// };
// // 获取详情
// export const getDetails = id => {
//   return axios.request({
//     url: `/tracker/trace/${id}`,
//     method: "GET"
//   });
// };
// // 更新列表
// export const update = data => {
//   return axios.request({
//     url: `/tracker/trace/${data.id}`,
//     method: "put",
//     data
//   });
// };

// // 删除列表
// export const deleteL = id => {
//   return axios.request({
//     url: `/tracker/trace/${id}`,
//     method: "DELETE"
//   });
// };


export const PickupCancel = data => {
  return axios.request({
    url: "/shipments/PickupCancel",
    method: "post",
    data
  });
};